import { SocialNetworks } from '@ui/league/SocialNetworks';
import FooterMobileContent from './FooterMobileContent';
import { Link } from 'react-router';
import { useNavigationsQuery } from '@data/navigations/useNavigationsQuery';
import { useDeviceType } from '@ui/utils/useDeviceType';
import { DeviceType } from '@repo/types';

// @ts-ignore
const siteName = import.meta.env.VITE_SITE_NAME;

function Footer() {
  const deviceType = useDeviceType();
  const { data, isLoading, error } = useNavigationsQuery();
  const isMobile = deviceType === DeviceType.mobile;

  if (isLoading) {
    return null;
  }

  const headerNavigation = data?.header;
  const navigationNodes = isMobile ? headerNavigation?.mobileNodes : headerNavigation?.desktopNodes;

  if (error || !navigationNodes || navigationNodes.length === 0 || !data) {
    return null;
  }

  const footerNavigation = data.footer;

  return (
    <footer className="footer">
      {siteName && <h2 className="footer__title">{siteName}</h2>}
      <div className="footer__nav-container">
        {footerNavigation.desktopNodes.map((node) => (
          <FooterMobileContent key={node.id} isMobile={isMobile} node={{ id: node.id, label: node.label }}>
            <ul className="footer__list">
              {node.children?.map(({ url, label, id }) => (
                <li key={id}>
                  <Link
                    className="footer__link"
                    to={url?.includes('.') && !url.startsWith('http') ? `https://${url}` : (url as string)}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </FooterMobileContent>
        ))}
        <SocialNetworks />
      </div>
      <Link className="footer__copyright" to="https://getleaguehub.com/" target={'_blank'}>
        &#169; Copyright 2024 LeagueHub | All rights reserved.
      </Link>
    </footer>
  );
}

export default Footer;
